<template>
  <div class="text-center my-10">
    <!-- <v-icon large color="vtred">mdi-block-helper</v-icon> -->
    <div class="text-h4 error--text">ACCESS DENIED!</div>
    <div class="mb-4 text-body-1">You do not have permission to view this web application.</div>
  </div>
</template>

<script>
export default {
  name: "AccessDenied",
  components: {},
};
</script>

<style lang="scss" scoped></style>
